import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  model,
  Output,
} from '@angular/core';
import {
  InputDirection,
  InputFieldSpacing,
  InputSize,
  InputVariant,
  InputWidth,
} from '@app/components/input';
import { SelectDropdownComponent } from '@app/components/select-dropdown';
import { TextInputComponent, TextInputType } from '@app/components/text-input';
import { ToggleHexColor } from '@app/components/toggle';
import { TenantValidator } from '@app/utils/validators/tenant-validator';
import { TranslatePipe } from '@ngx-translate/core';
import { EnterpriseTenant, ProvisioningTypes } from '@skyfit/core-data-library';

@Component({
  selector: 'app-tenant-general-form',
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    TextInputComponent,
    SelectDropdownComponent,
  ],
  templateUrl: './general-form.component.html',
  styleUrls: ['./general-form.component.css'],
})
export class GeneralFormComponent {
  @Input() readMode: boolean;
  @Input() tenant?: EnterpriseTenant;
  @Output() formSubmit = new EventEmitter<Event>();

  private readonly tenantValidator = new TenantValidator();
  readonly destroyRef = inject(DestroyRef);

  name = model('');
  description = model('');
  slugs = model('');
  emails = model('');
  provisioningType = model<ProvisioningTypes>(ProvisioningTypes.emailRegex);

  nameError = computed(
    () =>
      this.tenantValidator.validateName(this.name()).validationObj.error.name ??
      ''
  );
  descriptionError = computed(
    () =>
      this.tenantValidator.validateDescription(this.description()).validationObj
        .error.description ?? ''
  );
  slugsError = computed(
    () =>
      this.tenantValidator.validateSlugs(this.slugs()).validationObj.error
        .slugs ?? ''
  );
  emailsError = computed(
    () =>
      this.tenantValidator.validateEmails(this.emails(), true).validationObj
        .error.emails ?? ''
  );

  InputType = TextInputType;
  InputSize = InputSize;
  InputWidth = InputWidth;
  InputDirection = InputDirection;
  InputFieldSpacing = InputFieldSpacing;
  ToggleHexColor = ToggleHexColor;
  InputVariant = InputVariant;
  provisioningTypes = Object.values(ProvisioningTypes);
  ProvisioningTypes = ProvisioningTypes;

  handleDescription(event: Event) {
    const val = (event.target as HTMLInputElement).value;
    this.description.set(val);
  }

  handleProvisioningType(event: string) {
    this.provisioningType.set(event as ProvisioningTypes);
  }
}
